// extracted by mini-css-extract-plugin
export var container = "author-module--container--2uM1H";
export var info = "author-module--info--2FxSS";